export const formatPhoneNumber = (value: string | undefined): string => {
    if (!value) return 'xxxxxxxxxxxx';

    let phoneString = '';
    let mergedNumber = 0;

    value
        .toString()
        .split('')
        .forEach(n => {
            if (mergedNumber === 4) {
                phoneString = phoneString + '-' + n;
                mergedNumber = 0;
            } else {
                phoneString = phoneString + n;
            }

            mergedNumber = mergedNumber + 1;
        });

    return phoneString;
};
